import init from '../../res/js/index';
import '../../res/css/index.less';
init();